const BYTES_PER_GB = 1024 ** 3;

/**
 * Объём в гигабайтах с одной десятичной, без единицы измерения: подпись
 * («ГБ», «GB») приходит из перевода, поэтому в число её не вклеиваем.
 */
export function formatGb(bytes: number): string {
  return (bytes / BYTES_PER_GB).toFixed(1);
}
